var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1261,
    height: 1080,
    viewBox: "0 0 1261 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1261 0H0V1080H1261V0Z",
    fill: "#28565D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M815.65 384.725C721.643 336.53 643.89 381.631 630.135 485.505C627.748 503.565 643.322 527.313 662.191 536.992L968.996 694.249C987.866 703.928 1003.44 696.145 1001.17 675.69C987.411 557.647 909.658 432.82 815.65 384.725Z",
    fill: "url(#paint0_linear_65_44927)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M920.458 249.719C920.458 321.462 873.17 355.388 814.855 325.454C756.654 295.619 709.366 213.298 709.366 141.555C709.366 69.8115 756.654 35.8855 814.969 65.8202C873.283 95.6551 920.458 178.075 920.458 249.719Z",
    fill: "url(#paint1_linear_65_44927)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M861.12 354.79C767.112 306.595 689.359 351.696 675.605 455.57C673.218 473.63 688.791 497.379 707.661 507.057L1014.47 664.314C1033.34 673.993 1048.91 666.21 1046.63 645.755C1032.88 527.712 955.128 402.885 861.12 354.79Z",
    fill: "url(#paint2_linear_65_44927)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M965.927 219.785C965.927 291.528 918.639 325.454 860.324 295.519C802.123 265.684 754.835 183.364 754.835 111.621C754.835 39.8771 802.123 5.95115 860.438 35.8858C918.752 65.7207 965.927 148.141 965.927 219.785Z",
    fill: "url(#paint3_linear_65_44927)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M426.66 421.345L215 314.079V410.868L426.774 518.134L426.66 421.345Z",
    fill: "url(#paint4_linear_65_44927)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.968 368.36C257.968 376.343 252.626 380.035 245.919 376.742C239.326 373.349 233.87 364.169 233.87 356.187C233.87 348.204 239.212 344.512 245.919 347.805C252.626 351.198 257.968 360.378 257.968 368.36Z",
    fill: "#F1935C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M268.881 365.367L338.108 400.39V413.961L268.881 378.937V365.367Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M269.222 392.707L404.835 461.457V475.027L269.222 406.277V392.707Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M760.86 518.932L973.543 626.696V1028.72L760.86 921.054V518.932Z",
    fill: "url(#paint5_linear_65_44927)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M938.077 653.638L725.28 545.873V947.896L937.963 1055.66L938.077 653.638ZM794.621 606.74L865.667 642.662V658.627L794.621 623.204V606.74Z",
    fill: "url(#paint6_linear_65_44927)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M745.855 800.617L916.706 887.128V900.699L745.855 814.188V800.617Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M757.905 833.146L904.884 907.584V921.154L757.905 846.717V833.146Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.194 766.791C879.194 734.96 857.937 698.34 831.792 685.069C805.647 671.798 784.39 686.865 784.39 718.696C784.39 750.526 805.647 787.146 831.792 800.417C857.937 813.689 879.194 798.621 879.194 766.791Z",
    fill: "#F1935C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M496.001 195.338L708.684 303.103V705.125L496.001 597.361V195.338Z",
    fill: "url(#paint7_linear_65_44927)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M673.218 330.343L460.421 222.578V624.601L673.104 732.366L673.218 330.343ZM529.762 283.446L600.808 319.367V335.332L529.762 299.91V283.446Z",
    fill: "url(#paint8_linear_65_44927)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480.996 476.924L651.847 563.435V577.005L480.996 490.494V476.924Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M492.932 509.552L639.798 583.99V597.56L492.818 523.123L492.932 509.552Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.335 443.197C614.335 411.367 593.078 374.746 566.933 361.475C540.788 348.204 519.531 363.272 519.531 395.102C519.531 426.933 540.788 463.553 566.933 476.824C593.078 490.095 614.335 475.028 614.335 443.197Z",
    fill: "#9F9F9F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M614.335 667.408L276.043 495.982L276.156 650.744L584.553 807.003L614.449 845.819L614.335 667.408Z",
    fill: "url(#paint9_linear_65_44927)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.008 556.35V514.342L367.664 579.001V621.009L240.008 556.35Z",
    fill: "#F1935C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M527.375 661.022L453.26 623.504V637.074L527.375 674.592V661.022Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M527.375 688.263L384.487 615.92V629.491L527.375 701.833V688.263Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M527.375 715.403L354.364 627.695V641.265L527.488 728.974L527.375 715.403Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.676 684.471C545.676 697.243 554.315 711.911 564.887 717.299C575.459 722.687 584.098 716.7 584.098 703.928C584.098 691.156 575.459 676.488 564.887 671.1C554.202 665.712 545.562 671.699 545.676 684.471Z",
    fill: "#F1935C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M349.135 203.021C355.955 206.414 361.411 214.796 361.411 221.681V252.114L384.373 263.689C391.194 267.081 396.65 275.463 396.65 282.348C396.65 289.233 391.194 292.027 384.373 288.634L361.411 277.06V307.493C361.411 314.378 355.955 317.172 349.135 313.78C342.314 310.387 336.858 302.005 336.858 295.12V264.687L313.896 253.112C307.076 249.719 301.619 241.338 301.619 234.453C301.619 227.568 307.076 224.774 313.896 228.166L336.858 239.741V209.307C336.858 202.423 342.314 199.629 349.135 203.021Z",
    fill: "url(#paint10_linear_65_44927)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_44927",
    x1: 56411.9,
    y1: -5561.81,
    x2: 22728.7,
    y2: 22429.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_65_44927",
    x1: 19676.4,
    y1: 1701.15,
    x2: -2135.94,
    y2: 19827.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_65_44927",
    x1: 56457.4,
    y1: -5591.74,
    x2: 22774.2,
    y2: 22399.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_65_44927",
    x1: 19721.8,
    y1: 1671.22,
    x2: -2090.47,
    y2: 19797.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_65_44927",
    x1: 12784,
    y1: 6887.91,
    x2: 9047.74,
    y2: 14262.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_65_44927",
    x1: 13051,
    y1: 7230.29,
    x2: -3820.91,
    y2: 40529.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_65_44927",
    x1: 13022.4,
    y1: 7253.15,
    x2: -3849.67,
    y2: 40554.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_65_44927",
    x1: 12786.3,
    y1: 6905.67,
    x2: -4085.56,
    y2: 40205.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_65_44927",
    x1: 12757.5,
    y1: 6929.86,
    x2: -4114.53,
    y2: 40231.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_65_44927",
    x1: 24067,
    y1: 11438.2,
    x2: 11090.9,
    y2: 23012.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_65_44927",
    x1: 6332.95,
    y1: 4238.26,
    x2: 2509.59,
    y2: 7675.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRight);
export default __webpack_public_path__ + "static/media/LoginRight.6c3b8a43173c343d69263fecd264e5b9.svg";
export { ForwardRef as ReactComponent };